<template>
    <div id="main-wrapper" :class="{ 'is-desktop': isDesktop, 'is-mobile': !isDesktop }">
        <transition name="fade">
            <portal-target name="details-overlay" @change="portalChange"> </portal-target>
        </transition>

        <DesktopNav ref="nav" v-if="isDesktop"/>

        <div class="router" v-if="isAuthenticated">
            <keep-alive :max="8">
                <transition name="fade">
                    <router-view></router-view>
                </transition>
            </keep-alive>
        </div>

        <Theater></Theater>

        <CollectDid :isDidOpen="didOpen"></CollectDid>

        <Login :isAuthenticated="isAuthenticated" :setAuth="setAuth"></Login>

        <Nav v-if="!isDesktop"></Nav>
    </div>
</template>

<script>
const CollectDid = () =>  import('@/components/CollectDid')
const Nav = () =>  import('@/components/Nav')
const Theater = () =>  import('@/components/WOD')
const Login = () =>  import('@/components/Login')
const DesktopNav = () => import('@/components/desktop/DesktopNav')

export default {
    name: 'Home',

    components: {
        DesktopNav,
        CollectDid,
        Theater,
        Nav,
        Login,
    },

    data: function(){
        return {
            isAuthenticated: false,
            didCallback: function() {},
            didParams: null,
            didOpen: false,
        }
    },

    computed: { },

    watch: {
        $route() {
            if(window.did){ window.afetch('/wake?did=' + window.did) }
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    },

    mounted: function(){
        window.now = new Date()
        setInterval(() => { window.now = new Date() }, 60000)
        window.sportsData = [
            { img: 'https://cdn.studio14a.com/QB/icons/nfl.png', name: 'Football' },
            { img: 'https://cdn.studio14a.com/QB/icons/formula1.png', name: 'Formula1' },
            { img: 'https://cdn.studio14a.com/QB/icons/nba.png', name: 'Basketball' },
            { img: 'https://cdn.studio14a.com/QB/icons/ufc.png', name: 'MMA' },
            { img: 'https://cdn.studio14a.com/QB/icons/nhl.png', name: 'Hockey' },
            { img: 'https://cdn.studio14a.com/QB/icons/mlb.png', name: 'Baseball' },
            { img: 'https://cdn.studio14a.com/QB/icons/fifa.png', name: 'Soccer' }
        ]

        window.genres = [ { id: 28, name: "Action" }, { id: 12, name: "Adventure" }, { id: 16, name: "Animation" }, { id: 35, name: "Comedy" }, { id: 80, name: "Crime" }, { id: 99, name: "Documentary" }, { id: 18, name: "Drama" }, { id: 10751, name: "Family" }, { id: 14, name: "Fantasy" }, { id: 36, name: "History" }, { id: 27, name: "Horror" }, { id: 10402, name: "Music" }, { id: 9648, name: "Mystery" }, { id: 10749, name: "Romance" }, { id: 878, name: "Science Fiction" }, { id: 53, name: "Thriller" }, { id: 10752, name: "War" }, { id: 37, name: "Western" }, { id: 10759, name: "Action & Adventure" }, { id: 16, name: "Animation" }, { id: 35, name: "Comedy" }, { id: 80, name: "Crime" }, { id: 99, name: "Documentary" }, { id: 18, name: "Drama" }, { id: 10751, name: "Family" }, { id: 9648, name: "Mystery" }, { id: 10763, name: "News" }, { id: 10764, name: "Reality" }, { id: 10766, name: "Soap" }, { id: 10767, name: "Talk" }, { id: 10768, name: "War & Politics" }, { id: 37, name: "Western" } ],
        window.features = [ { name: "Keanu Reeves", id: 6384 }, { name: "Angelina Jolie", id: 11701 }, { name: "Denzel Washington", id: 5292 }, { name: "Scarlett Johansson", id: 1245 }, { name: "Robert De Niro", id: 380 }, { name: "Morgan Freeman", id: 192 }, { name: "Tom Hardy", id: 2524 }, { name: "Brad Pitt", id: 287 }, { name: "Anne Hathaway", id: 1813 }, { name: "Henry Cavill", id: 73968 }, { name: "Dwayne Johnson", id: 18918 }, { name: "Joaquin Phoenix", id: 73421 }, { name: "Chloë Grace Moretz", id: 56734 }, { name: "Tom Holland", id: 1136406 }, { name: "Will Smith", id: 2888 }, { name: "Leonardo DiCaprio", id: 6193 }, { name: "Tom Cruise", id: 500 }, { name: "Christian Bale", id: 3894 }, { name: "Matt Damon", id: 1892 }, { name: "George Clooney", id: 1461 }, { name: "Johnny Depp", id: 85 }, { name: "Ryan Reynolds", id: 10859 }, { name: "Ryan Gosling", id: 30614 }, { name: "Chris Hemsworth", id: 74568 }, { name: "Chris Evans", id: 16828 }, { name: "Chris Pratt", id: 73457 }, { name: "Robert Downey Jr.", id: 3223 }, { name: "Mark Ruffalo", id: 73421 }, { name: "Jeremy Renner", id: 502 }, { name: "Samuel L. Jackson", id: 2231 }, { name: "Nicolas Cage", id: 2963 }, { name: "Hugh Jackman", id: 6968 }, { name: "Jake Gyllenhaal", id: 131 }, { name: "Joseph Gordon-Levitt", id: 24045 }, { name: "James McAvoy", id: 5530 }, { name: "Michael Fassbender", id: 17288 }, { name: "Oscar Isaac", id: 1813 }, { name: "Pedro Pascal", id: 1253360 }, { name: "Cillian Murphy", id: 39972 }, { name: "Benedict Cumberbatch", id: 71580 }, { name: "Daniel Craig", id: 8784 }, { name: "Idris Elba", id: 17605 }, { name: "Jason Statham", id: 976 }, { name: "Gerard Butler", id: 17276 }, { name: "Liam Neeson", id: 3895 }, { name: "Harrison Ford", id: 3 }, { name: "Arnold Schwarzenegger", id: 1100 }, { name: "Sylvester Stallone", id: 16483 }, { name: "Bruce Willis", id: 62 },  { name: "Natalie Portman", id: 524 }, { name: "Emma Stone", id: 54693 }, { name: "Emma Watson", id: 10990 }, { name: "Jennifer Lawrence", id: 72129 }, { name: "Margot Robbie", id: 234352 }, { name: "Florence Pugh", id: 1373737 }, { name: "Zendaya", id: 505710 }, { name: "Anya Taylor-Joy", id: 1397778 }, { name: "Jenna Ortega", id: 974169 }, { name: "Gal Gadot", id: 90633 }, { name: "Charlize Theron", id: 6886 }, { name: "Sandra Bullock", id: 18277 }, { name: "Julia Roberts", id: 1204 }, { name: "Nicole Kidman", id: 2227 }, { name: "Cate Blanchett", id: 112 }, { name: "Amy Adams", id: 9273 }, { name: "Emily Blunt", id: 5081 }, { name: "Jessica Chastain", id: 1245 }, { name: "Saoirse Ronan", id: 7010 }, { name: "Michelle Williams", id: 6161 }, { name: "Viola Davis", id: 19492 }, { name: "Octavia Spencer", id: 50876 }, { name: "Tilda Swinton", id: 3061 }, { name: "Michelle Yeoh", id: 1620 }, { name: "Sigourney Weaver", id: 10205 }, { name: "Jamie Lee Curtis", id: 8944 }, { name: "Meryl Streep", id: 5064 }, { name: "Jodie Foster", id: 51701 }, { name: "Halle Berry", id: 4587 }, { name: "Zoe Saldana", id: 8691 }, { name: "Jessica Alba", id: 56731 }, { name: "Mila Kunis", id: 1892 }, { name: "Jennifer Aniston", id: 4491 }, { name: "Reese Witherspoon", id: 368 }, { name: "Kristen Stewart", id: 7219 }, { name: "Dakota Johnson", id: 15686 }, { name: "Elizabeth Olsen", id: 9279 }, { name: "Rachel McAdams", id: 5947 }, { name: "Keira Knightley", id: 5064 }, { name: "Rosamund Pike", id: 1204 }, { name: "Charlize Theron", id: 6886 } ],

        window.shuffle = function (array) {
          let currentIndex = array.length,  randomIndex;

          while (currentIndex != 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            [array[currentIndex], array[randomIndex]] = [
              array[randomIndex], array[currentIndex]];
          }

          return array;
        }

        window.getAssetColor = function(asset){
            if(asset && asset.colors && asset.colors.Vibrant){
                return `rgba(${asset.colors.Vibrant._rgb.join(',')}, 0.8)`
            }
        }
        window.getTime = function(time){
            const date = new Date(time);
            const options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
                timeZoneName: 'short' // optional: shows the client timezone
            };

            return date.toLocaleString('en-US', options);
        }

        window.afetch = (url, options = {}) => {
            const defaultHeaders = {
                'Authorization': window.localStorage.getItem('authToken'),
                "Content-Type": "application/json"
            };

            const mergedHeaders = {
                ...defaultHeaders,
                ...options.headers,
            };

            return fetch(process.env.VUE_APP_SERVER + url, {
                ...options,
                headers: mergedHeaders,
            });
        };

        window.qb = window.location.host.split('.')[0]


        this.$nextTick(() => {
            this.init()
            window.addEventListener("focus", this.init);
            if(!window.localStorage.getItem('cid')){
                const id = window.crypto.randomUUID();
                window.localStorage.setItem('cid', id)
            }
        })

        //did events
        this.$root.$on('collectDid', (payload) => {this.collectDid(payload)})

        this.$root.$on('newDid', (d) => {
          window.did = d
          if(d){
              sessionStorage.setItem('lastDid', d)
              window.afetch('/wake?did=' + d)
              this.$root.$emit('getRemote')
          }else{
              sessionStorage.removeItem('lastDid')
          }
          this.$root.$emit('newDidSet', d)
        })

        //notifs register
        this.$nextTick( async () => {
            window.swReg = await navigator.serviceWorker.register('/sw.js');
            window.pushSub = await window.swReg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: 'BAFOAzDEN0m4yZ4Ff7KM785xEhBlAHNjhoZhOfTwMjghE5s3Hf78kahtCepQaIwQjxoE1CeI3pT7VFC3J1KjrZY'
            });
            window.Notification.requestPermission()
        })
    },

    methods: {
        init(){
            const someDid = sessionStorage.getItem('lastDid')
            if(someDid !== null || someDid !== undefined || someDid !== ''){ window.did = someDid }
            const wakeDid = window.did ? window.did : 'all'
            window.afetch(`/wake?did=${wakeDid}`)
            this.$root.$emit('getRemote')
        },

        setAuth(state){
            this.isAuthenticated = state
        },

        collectDid(data){
            this.didOpen = true
            this.didCallback = data.cb
            this.didParams = data.params
        },

        portalChange(hasContent) {
            document.documentElement.style.overflowY = hasContent ? 'hidden' : '';
        }
    }
}
</script>


<style lang="scss">

@viewport { orientation: portrait; }

@media (min-width: 700px) {
    @viewport { orientation: auto; }
}

*::-webkit-scrollbar{ display: none; }

*{
    transition: all 300ms cubic-bezier(0.000, 0.000, 0.580, 1.000); /* ease-out */
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
            -webkit-tap-highlight-color: transparent;
            -moz-tap-highlight-color: transparent;
            -ms-tap-highlight-color: transparent;
            -khtml-tap-highlight-color: transparent;

}

.is-desktop * {
    -webkit-user-select: auto;
       -moz-user-select: auto;
        -ms-user-select: auto;
            user-select: auto;
    -webkit-tap-highlight-color: auto;
}

.is-desktop{
    min-height: 100vh;

    .router {
        padding-top: 0;
        min-height: 100vh;
    }

    .secondary-header{
        display: none!important;
        pointer-events: none!important;
    }
}

a{
    text-decoration: none;
}

html, body, #app {
    padding: 0;
    margin: 0;
    width: 100vw;
    height: auto;
    overflow-x: hidden;
    font-family: 'Work Sans', sans-serif;
    color: white;
    background-color: #141414;
    padding-bottom: 30px;
    &.remoteOpen{
        padding-bottom: 120px;
    }
    &.remoteActive{
        overflow: hidden;
    }

    #main-wrapper{
        display: block;
        position: relative;
    }
}

h1{
    padding: 0 20px
}

.content-row{
    display: flex;
    flex-direction: row;
    width: calc(100% - 40px);
    padding: 0 20px;
    overflow: scroll;
    margin-bottom: 20px;
}

.section.offset{
    margin-top: 40px;
}

.section-tabs{
    padding: 20px;
    padding-top: 80px;
}

.fadeui-enter-active, .fadeui-leave-active {
  transition: 0.3s;
  transform: translateY(0px);
}

.fadeui-enter, .fadeui-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(70px);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.loader{
    position: absolute;
    top: 50%;
    right: calc(50% - 40px);
}

@keyframes placeHolderShimmer {
    0% {
        background-position: 0px 0;
    }
    100% {
        background-position: 100em 0;
    }
}

.animated {
    pointer-events: none;
    opacity: 0.1!important;
    animation-duration: 3s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: fff;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 8%, #eeeeee 33%);
    height: 100vh;
    width: 100%;
    position: absolute;
    padding-top: 50px;
    -webkit-backface-visibility: hidden;
    left:0;
    right:0;
    top:0;
    bottom:0;
}

.off{
    pointer-events: none!important;
    display: none!important;
}

#installInstructions {
   display: none
}
@media (display-mode: browser) {
   #installInstructions {
     display: block
   }
}
img{
    pointer-events: none;
}

.secondary-header{
    display: flex;
    flex-direction: row;
    padding: 10px 20px;
    position: absolute;
    width: calc(100% - 40px);
    top: 0;
    left: 0;
    z-index: 99;
    justify-content: space-between;
    border-bottom: 1px solid rgba(white, 0.1);

    .save{
        backdrop-filter: blur(15px);
        border-radius: 5px;
        padding: 10px;
    }

    > div{
        display: flex;
        align-items:center;
        font-size: 9px;
    }
    svg{
        width: 20px;
        padding-right: 5px;
    }

}

.save .saved { fill: white; }

.popup{
    position: fixed;
    top: 20px;
    z-index: 999;
    backdrop-filter: blur(15px);
    background-color: rgba(black, 0.1);
    border-radius: 5px;
    color: white;
    padding: 10px;
    left: 50vw;
    transform: translateX(-50%);
    font-size: 9px;
    text-align: center;

}

.expanded-details-modal{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    .details-wrapper{
        position: relative;
        width: 800px;
        height: 80vh;
        overflow-y: scroll;
        background-color: #141414;
        border-radius: 12px;
        box-shadow: 0 0px 40px -8px rgba(0, 0, 0, 0.85);
        z-index: 2;
    }
    .backdrop{
        position: absolute;
        cursor: pointer;
        z-index: 1;
        background-color: rgba(black, 0.5);
        backdrop-filter: blur(2px);
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
}
</style>
